import { LanguageState, REQUEST_LANGUAGES } from "./types";

const initialState: LanguageState = {
  languages: []
};

export function languageReducer(state = initialState, action: any) {
  switch (action.type) {
    case REQUEST_LANGUAGES:
      return action.payload;
    default:
      return state;
  }
}
